var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.note.length)?_c('div',{staticClass:"subsidy-note"},[_c('img',{attrs:{"src":require("@/assets/img/warning.svg")}}),_vm._v("\n    "+_vm._s(_vm.note)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }